module.exports = __webpack_public_path__ + "media/images/application/template/icon-placeholder-5f6d8ff26e4940cedaabdec181848391.svg";